module.exports = require("react-pubsub-via-radio.js/service");



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/react-pubsub-via-radio.js/service.js
// module id = 35
// module chunks = 0 1 2 3 4